module.exports = __webpack_public_path__ + "img/app-icon.cf55a6b8.png";